<template>
	<div class="bg">
        <!-- 顶部导航 -->
		<common-head :active="0" ></common-head>

        <!-- 轮播图信息 -->
		<common-slide ></common-slide>

        <!-- 首页广告 -->
		<index-banner></index-banner>

        <!-- 活动列表 -->
		<index-activity></index-activity>

		<!-- 底部信息 -->
		<common-footer></common-footer>

	</div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
    import { share } from "@/static/js/share.js";
	import commonHead from '@/components/wap/commonHead.vue';
	import commonSlide from '@/components/wap/commonSlide.vue';
    import indexBanner from '@/components/wap/indexBanner.vue';
    import indexActivity from '@/components/wap/indexActivity.vue';
    import commonFooter from '@/components/wap/commonFooter.vue';
	export default {
		name: 'index',
		components: {
			commonHead,commonSlide,indexBanner,indexActivity,commonFooter
		},
		data() {
			return {
				
			}
		},
		metaInfo() {
            site_name().then(res => {
                document.title = res.site_name;
                share(window.location.pathname + window.location.search, '首页-' + res.site_name);
                return {
                    title: '首页-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
                    ],
                }
            });
		},
	}
</script>
<style scoped lang="less">
	.bg{
		background-color: #f2f2f2;
	}
</style>